import { types, actions } from './requests'
export const MERGEMASTER_TYPES = {
    ...types('MERGEMASTER'),
}
export const MERGEMASTER_ACTIONS = {
    ...actions('MERGEMASTER'),
}